import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const paychecksJourneyRoutes = [
  {
    id: 'paychecks-distribution-summary',
    trackingName: 'View Paychecks Distribution Summary',
    path: 'dl/view/paychecks/distribution-summary',
    lazy: async () => ({
      Component: (await import('../components/JourneyEditDistributions')).JourneyEditDistributions,
    }),
  },
  {
    id: 'paychecks-add-or-edit-allocation',
    trackingName: 'Add or Edit Paychecks Allocation',
    path: 'dl/view/paychecks/edit-allocation/:paychecksAllocationId',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddOrEditAllocation')).JourneyAddOrEditAllocation,
    }),
  },
  {
    id: 'paychecks-view-paychecks-activity',
    trackingName: 'View Paychecks Activity',
    path: 'dl/view/paychecks/activity',
    lazy: async () => ({
      Component: (await import('../components/JourneyViewPaychecksActivity')).JourneyViewPaychecksActivity,
    }),
  },
  {
    id: 'paychecks-view-paycheck',
    trackingName: 'View Paycheck',
    path: 'dl/view/paychecks/view-paycheck',
    lazy: async () => ({
      Component: (await import('../components/JourneyViewPaycheck')).JourneyViewPaycheck,
    }),
  },
] as const satisfies JourneyRoute[]
